<div class="statements-invoices">
  <table class="page-table">

    <tr>
      <td colspan="3">
        <kendo-grid class="statements-invoices-table"
                    #statementsparentsDataTable
                    [kendoGridBinding]="invoices"
                    [loading]="loading"
                    [pageSize]="pageSize"
                    [resizable]="true"
                    [pageable]="{
                            buttonCount: buttonCount,
                            info: info,
                            type: type,
                            pageSizes: pageSizes,
                            previousNext: previousNext
                            }"
                    [sortable]="true"
                    [sort]="sort"
                    [scrollable]="true"
                    (pageChange)="pageChange($event)"
                    [selectable]="{
                      mode: 'multiple',
                      checkboxOnly: false}"
                    filterable="menu"
                    (selectionChange)="allRowsSelected($event)"
                    [rowSelected]="isRowSelected"
                    [skip]="skip"
                    [kendoGridSelectBy]="selectionKey"
                    [selectedKeys]="selectedKeys"
                    [reorderable]="true"
                    [filter]="">
          <ng-template kendoGridToolbarTemplate>
            <input type="checkbox" class="master-select " [(ngModel)]="masterSelect" (click)="masterClicked()"
                   kendoCheckBox/>
            <label class="k-checkbox-label" style="padding-top: 10px;">All Records</label>
            <kendo-grid-column-chooser style="margin-left: auto;"></kendo-grid-column-chooser>
          </ng-template>
          <kendo-grid-checkbox-column [width]="75" [showSelectAll]="true" [reorderable]="false"
                                      [columnMenu]="false">
            <ng-template kendoGridHeaderTemplate>
              <input class="k-checkbox" id="selectAllCheckboxId" kendoGridSelectAllCheckbox
                     [state]="selectAllState"
                     (selectAllChange)="allRowsSelected($event)">
              <label class="k-checkbox-label" for="selectAllCheckboxId">Page</label>
            </ng-template>
          </kendo-grid-checkbox-column>

          <kendo-grid-column field="invoiceNumber" title="Invoice Number" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="invoiceClass" title="Type" [width]="90"></kendo-grid-column>
          <kendo-grid-column field="shipToSiteNumber" title="Customer" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="storeNumber" title="Store" [width]="200"></kendo-grid-column>
          <kendo-grid-column field="invoiceDate" title="Invoice Date" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="invoiceDueDate" title="Due Date" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="origBalance" title="Original Amount" [width]="150"></kendo-grid-column>
          <kendo-grid-column field="dueBalance" title="Balance Due" [width]="150"></kendo-grid-column>
        </kendo-grid>
      </td>
      <td style="display:none;">
        <kendo-grid #statementsInvoicesData>
          <kendo-grid-column field="billToSiteNumber" title="Parent Customer Number"></kendo-grid-column>
          <kendo-grid-column field="storeNumber" title="Parent Store Number"></kendo-grid-column>
          <kendo-grid-column field="billToSiteName" title="Parent Description"></kendo-grid-column>
          <kendo-grid-column field="shipToSiteNumber" title="Customer Number"></kendo-grid-column>
          <kendo-grid-column field="storeNumber" title="Store Number"></kendo-grid-column>
          <kendo-grid-column field="shipToSiteName" title="Store Description"></kendo-grid-column>
          <kendo-grid-column field="invoiceNumber" title="Invoice Number"></kendo-grid-column>
          <kendo-grid-column field="invoiceClass" title="Document Type"></kendo-grid-column>
          <kendo-grid-column field="invoiceDate" title="Invoice Date"></kendo-grid-column>
          <kendo-grid-column field="invoiceDueDate" title="Net Due Date"></kendo-grid-column>
          <kendo-grid-column field="origBalance" title="Original Amount"></kendo-grid-column>
          <kendo-grid-column field="dueBalance" title="Balance Due if paid by Net"></kendo-grid-column>
          <kendo-grid-column field="discountAmount" title="Discount if paid by Disc. Due Date"></kendo-grid-column>
          <kendo-grid-column field="amount" title="Balance Due if paid by Disc. Due Date"></kendo-grid-column>
          <kendo-grid-column field="discountDate" title="Discount Due Date"></kendo-grid-column>
          <kendo-grid-excel fileName="Statement_export.xlsx" [fetchData]="exportAllData"></kendo-grid-excel>
        </kendo-grid>
        </td>
    </tr>
    <tr>
      <td>

        <table class="b-button-bar">
          <tr>
            <td>
              <app-mcl-button text="< Back To Store Selection" primary="true" (click)="backClicked()">
              </app-mcl-button>
            </td>
            <td>
              <div style="width: 150px;">
              </div>
            </td>
            <td>
              <app-mcl-button text="Download" primary="true" [svgIcon]="downloadIcon" (buttonPressed)="exportAsXLSX(statementsInvoicesData)" [disabled]="noSelection">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="View Statement" primary="true" (click)='viewStatement()' [disabled]="noSelection">
              </app-mcl-button>
            </td>
            <td>
              <app-mcl-button text="View Invoice" primary="true" (click)='viewInvoice()' [disabled]="noSelection">
              </app-mcl-button>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>

  <div kendoDialogContainer></div>
</div>
